import React from 'react';
import TabContainer from '../../components/TabContainer';
import KullanicilarPage from '../admin/KullanicilarPage';
import MasterVerilerPage from '../admin/MasterVerilerPage';
import VeriDuzeltmePage from '../admin/VeriDuzeltmePage';
import SistemAyarlariPage from '../SistemAyarlariPage';
import LogKayitlariPage from '../admin/LogKayitlariPage';
import YedeklemePage from '../admin/YedeklemePage';
import PosTerminalleriPage from '../ayarlar/PosTerminalleriPage';
import KomisyonOranlariPage from '../ayarlar/KomisyonOranlariPage';
import SatisKanallariPage from '../ayarlar/SatisKanallariPage';
import FizibiliteMasterDataPage from '../ayarlar/FizibiliteMasterDataPage';
import { useAuth } from '../../auth/AuthProvider';
import { PERMISSIONS, hasPermission } from '../../auth/permissions';

const YonetimPage = () => {
  const { user } = useAuth();
  const canViewFeasibility = hasPermission(
    user?.role,
    PERMISSIONS.VIEW_FEASIBILITY,
    user?.effectivePermissions,
  );

  const tabs = [
    { id: 'kullanicilar', label: 'Kullanıcılar', icon: '👥', component: <KullanicilarPage /> },
    { id: 'master-veriler', label: 'Master Veriler', icon: '📁', component: <MasterVerilerPage /> },
    { id: 'pos-terminalleri', label: 'POS Terminalleri', icon: '💳', component: <PosTerminalleriPage /> },
    { id: 'komisyon-oranlari', label: 'Komisyon Oranları', icon: '🏦', component: <KomisyonOranlariPage /> },
    { id: 'satis-kanallari', label: 'Satış Kanalları', icon: '🛒', component: <SatisKanallariPage /> },
    ...(canViewFeasibility
      ? [{ id: 'fizibilite-tanimlar', label: 'Yatırım Fizibilite', icon: '📈', component: <FizibiliteMasterDataPage /> }]
      : []),
    { id: 'veri-duzeltme', label: 'Veri Düzeltme', icon: '🔧', component: <VeriDuzeltmePage /> },
    { id: 'ayarlar', label: 'Sistem Ayarları', icon: '⚙️', component: <SistemAyarlariPage /> },
    { id: 'yedekleme', label: 'Yedekleme', icon: '💾', component: <YedeklemePage /> },
    { id: 'log-kayitlari', label: 'Sistem Logları', icon: '📜', component: <LogKayitlariPage /> },
  ];
  return <TabContainer title="Yönetim" tabs={tabs} defaultTab="kullanicilar" />;
};

export default YonetimPage;
